export enum IssueSubType {
    Other = 0,
    All = 1,

    SystemFailure_Configuration = 41105,
    SystemFailure_ConfigurationIncomplete = 41106,
    ConnectionFailure_VideoStream = 41201,
    ConnectionFailure_Monitoring = 41203,
    ConnectionFailure_AlarmTransfer = 41204,
    ConnectionFailure_ImageUpload = 41205,
    VideoQualityFailure_Brightness = 41303,
    VideoQualityFailure_Contrast = 41304,
    Tampering_Redirected = 41501,
    Tampering_Covered = 41502,
}
